import React, { Component } from 'react';
import { connect } from 'react-redux';
import { service, translate } from '../../services';
import { BusyContainer, IconButton } from '..';
import { busyState, identityState, messageDispatcher, productState, priceState, currentNodeState, combineStates, combineDispatchers, cartDispatcher } from '../../store';
import { UserIdentity, getTransformedProducts, getAccessories } from '../../util'

export class ExportToPartnerHubComponent extends Component{
  constructor() {
    super();
    this.state= {
      isBusy: false
    }
    this.getProduct = this.getProduct.bind( this );
  }
  hidePopup = () => this.props.hidePopup();
  deleteFromCart = items => {
    for(const item of items ){
      this.props.deleteFromCart( item );
    }
  }
  getProduct( product ) {
    const { prices } = this.props;
    if ( !prices || !product || ( prices && !prices[ product.name ])){
      return product;
    }
    return { ...product, ...prices[product.name] };
  }
  exportToExternalCart = async () => {
    const { cartItems, products, user, currentNode } = this.props;
    this.props.getExportStatus( true );
    const cachedProducts = cartItems.map( item => {
      if ( item.configuration && item.configuration.bomComponents && item.configuration.bomComponents.length ) {
        item.children = item.configuration.bomComponents.map( c => products[c.component] ).map( this.getProduct );
      } else {
        item.children = getAccessories( item ).map( accessoryCode => products[accessoryCode] ).map( this.getProduct );
      }
      if ( item.additionalProduct != undefined && item.additionalProducts[0].configuration && item.additionalProducts[0].configuration.bomComponents && item.additionalProducts[0].configuration.bomComponents.length ) {
        item.additionalProducts = item.additionalProducts.map( this.getProduct );
        item.additionalProducts[0].children = item.additionalProducts[0].configuration.bomComponents.map( c => products[c.component] ).map( this.getProduct );
      } else if(item.additionalProduct != undefined && item.additionalProducts.length > 0) {
        item.additionalProducts = item.additionalProducts.map( this.getProduct );
        item.additionalProducts[0].children = getAccessories( item.additionalProducts[0] ).map( accessoryCode => products[accessoryCode] ).map( this.getProduct );
      }
      return item;
    } ).map( this.getProduct );
    const transformedProducts = getTransformedProducts( cachedProducts, products, user.authenticationType, 
      currentNode, null, false, null, null );
    const amount = cartItems.reduce( ( total, item ) => total += item.amount, 0 );
    const isPMPortalCall = user.authenticationType === 'PartnerHub' && user.properties.source === 'pmportal';
    this.setState( { isBusy: true } );
    await service( 'sendToExternal/ph' ).post( transformedProducts, UserIdentity.token.split('?')[0] )
      .then( () => {
        this.mounted && this.setState( { isAdding: false } );
        if( isPMPortalCall ){
          this.props.addMessage( { timeout: 5000, messageText: translate( '{amount} {tr:product} Sent To PM Portal', { amount, product: amount === 1 ? 'product' : 'products' } ), messageType: 'confirmation' } );
        } else{
          this.props.addMessage( { timeout: 5000, messageText: translate( '{amount} {tr:product} Sent To PartnerHub', { amount, product: amount === 1 ? 'product' : 'products' } ), messageType: 'confirmation' } );
        }
        this.deleteFromCart(cartItems);
      } )
      .catch( () => {
        this.props.addMessage( { timeout: 10000, messageText: translate( 'Problem in communication. Please try again.' ), messageType: 'error' } );
        this.mounted && this.setState( { isAdding: false } );
      } );
      this.setState( { isBusy: false } );
    this.props.hidePopup();
  }
  
  render(){
    return <BusyContainer isBusy={ this.state.isBusy }>
        <div className="export-cart-panel" >
          <div className="actions" >
            <IconButton text={ translate( 'Cancel' ) } onClick={ this.hidePopup } />
            <IconButton className="blue-button" text={ translate( 'OK' ) } onClick={ this.exportToExternalCart }/>
          </div>
        </div>
    </BusyContainer>
  }
}

export const ExportToPartnerHub = connect( combineStates( busyState, identityState, productState, currentNodeState, priceState ), combineDispatchers( cartDispatcher, messageDispatcher) )( ExportToPartnerHubComponent );
